/**
 * GSAP 전역 초기화
 *
 * - useGSAP hook 은 호출 측 컴포넌트에서 직접 import.
 * - ScrollTrigger 는 이 파일에서 한 번만 registerPlugin.
 * - prefers-reduced-motion 준수 (디자인.md §11).
 */

import { useGSAP } from '@gsap/react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

let registered = false;

export function registerGsap() {
  if (registered) return;
  gsap.registerPlugin(useGSAP, ScrollTrigger);

  if (
    typeof window !== 'undefined' &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches
  ) {
    gsap.globalTimeline.timeScale(0);
  }

  registered = true;
}

export { gsap };
